<div class="relative">
  <div
    class="h-15 min-w-15 flex gap-1 justify-center rounded-lg px-1 text-gray-700 active:bg-branding-50 transition-colors text-xs"
    [class.bg-branding-50]="active()"
  >
    <div class="flex flex-col justify-center items-center">
      <ng-content></ng-content>
    </div>
  </div>
</div>
